import { render, staticRenderFns } from "./likeFollowDetail.vue?vue&type=template&id=0fda4e44&scoped=true&"
import script from "./likeFollowDetail.vue?vue&type=script&lang=js&"
export * from "./likeFollowDetail.vue?vue&type=script&lang=js&"
import style0 from "./likeFollowDetail.vue?vue&type=style&index=0&id=0fda4e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda4e44",
  null
  
)

export default component.exports